// extracted by mini-css-extract-plugin
export default {"message":"RejectPopup_message__Z8Kv+","confirmButton":"RejectPopup_confirmButton__tIcRQ"};